import axios from 'axios';

/**
 * 获取订单列表
 *
 * @param {*} params
 * @param {string} key        授权Token
 * @param {string} type       筛选关键字
 * @param {string} order_type
 * @param {number} seller_id
 * @param {number} doc_remark
 * @param {number} pay_status
 * @param {string} is_print
 * @param {string} sn
 * @param {string} print_type
 * @param {string} sday	      开始时间，格式：YYYY-MM-DD
 * @param {string} eday	      结束时间，格式：YYYY-MM-DD
 * @param {number} page	      页码
 */
export function requestOrderList(params) {
  return axios.get('/order/new_view_all', { params });
}
/**
 * 搜索订单
 *
 * @param {*} params
 * @param {string} key      授权 Token
 * @param {number} id       指定订单 ID
 * @param {string} keyword  关键词
 * @param {number} page     页码
 * @param {number} page_num 条数/页
 */
export function requestOrderSearch(params) {
  return axios.get(`/order/search_by_id/${params.id}`, { params: params.body });
}
/**
 * 批量删除订单
 *
 * @param {*} params
 * @param {string} key     授权 Token
 * @param {array}  doc_id  订单 ID 数组
 */
export function requestOrderDeleteBatch(params) {
  return axios.post('/order/batch_del', params);
}
/**
 * 删除订单
 *
 * @param {*} params
 * @param {string} key     授权 Token
 * @param {string} id      订单 ID
 * @param {string} restore 是否回滚库存
 */
export function requestOrderDelete(params) {
  return axios.post('/order/del', params);
}
/**
 * 设置订单标签
 *
 * @param {*} params
 * @param {string} key     授权 Token
 * @param {string} id      订单 ID
 * @param {string} tag
 * @param {string} remark
 * @param {string} goods_status
 * @param {string} money_status
 * @param {string} pos_payment
 */
export function requestOrderSetTag(params) {
  return axios.post('/order/set_tag', params);
}
/**
 * 订单导出
 *https://www.eolinker.com/#/share/project/api/detail?groupID=-1&apiID=1828884&shareCode=bP1asu&shareToken=$2y$10$i~2FigILd~2FgxFghEqEMQcV8O~2FC3yaMb2bBt0YXfkIpy03o3k0Qn~2F99m&shareID=102684
 */
// export function requestGetExcelMc(params) {
//   return axios.get('/report/export_doc_info_mc', { responseType: 'blob', params: params });
// }
export function requestGetExcel(params) {
  return axios.get('/report/export_doc_info_mc', { responseType: 'blob', params: params });
}

// 获取订单退货信息
export function requestGetReturnInfo(params) {
  return axios.get('/order/get_doc_return_info', { params: params });
}

// 创建退货单
export function addReturnDoc(params) {
  return axios.post('/order/add_return_doc', params);
}

// 获取支付方式
export function getPayment() {
  return axios.post('/user/get_payment');
}
